import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import TextButton from '../TextButton/TextButton';
import './Popup.scss';

const Popup = ({ isOpen, onClose, children, title, closeOnOverlayClick = true }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('popup-open');
    } else {
      document.body.classList.remove('popup-open');
    }
    return () => {
      document.body.classList.remove('popup-open');
    };
  }, [isOpen]);

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="popup" onClick={handleOverlayClick}>
      <div className="popup__container">
        <div className={`popup__header ${!title ? 'popup__header--no-title' : ''}`}>
          {title && <h3 className="popup__title">{title}</h3>}
          <TextButton onClick={onClose} className="popup__close-button">
            <div className="popup__close-btn" />
          </TextButton>
        </div>
        <div className="popup__content">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Popup;
